import { cn } from "@/lib/utils";
import { JSX } from "react";

export const ComponentContainer = ({
  children,
  marginBottom,
  marginTop,
  dark,
  onBoarding,
  title,
}: {
  children: React.ReactNode;
  marginBottom?: string;
  marginTop?: string;
  dark?: boolean;
  onBoarding?: boolean;
  title?: React.JSX.Element | string;
}) => (
  // No overflow-hidden: dropdown panels inside must hang out of it
  <article
    className={cn(
      "flex flex-col text-foreground w-full justify-center border border-edge-strong rounded-lg mobile:rounded-none mobile:border-x-0 sb-v2-lg:border-x sb-v2-lg:rounded-lg",
      marginBottom,
      marginTop,
      onBoarding && "z-21 shadow-white-glow pointer-events-none",
    )}
  >
    {title && (
      <div className="px-3 py-1.5 text-sm border-b border-edge-strong bg-surface-raised rounded-t-lg mobile:rounded-none sb-v2-lg:rounded-t-lg">
        {title}
      </div>
    )}
    <div
      className={
        dark
          ? "bg-black/[0.7] p-2 rounded-lg"
          : "py-4 mobile:px-2 px-4 sb-v2-lg:px-4"
      }
    >
      {children}
    </div>
  </article>
);
